module.exports = __webpack_public_path__ + "img/step1.f224f10c.png";